import React from 'react';
import { ReactComponent as WarningIcn } from '../../assets/warning-exclamation.svg';
import TwTooltip from '../TwTooltip/TwTooltip';
import Box from '@mui/material/Box';

export interface TwWarningIconProps {
  message: string;
}

const TwWarningIcon: React.FC<TwWarningIconProps> = ({ message }) => {
  return (
    <TwTooltip title={message} placement="top">
      <Box component="span" sx={{ display: 'flex' }}>
        <WarningIcn />
      </Box>
    </TwTooltip>
  );
};

export default TwWarningIcon;
